module.exports = __webpack_public_path__ + "static/media/github.36e782c8.svg";